import {IContentData} from "~/lib/data-contract";

export type ParsedContentType = { [key: string]: IContentData[] } | string[] | null;

export const parseProductContent = (content: string | undefined): ParsedContentType => {
    if (!content) return null;

    try {
        const parsed = JSON.parse(content);

        if (Array.isArray(parsed) && parsed.every(item => typeof item === "string")) {
            return parsed;
        }

        if (typeof parsed === "object" && !Array.isArray(parsed)) {
            const restoredContent: { [key: string]: IContentData[] } = {};
            for (const key in parsed) {
                if (Array.isArray(parsed[key])) {
                    restoredContent[key] = parsed[key] as IContentData[];
                } else {
                    restoredContent[key] = [parsed[key] as IContentData];
                }
            }
            return restoredContent;
        }

        return null;
    } catch (e) {
        console.error("Failed to parse product content:", e);
        return null;
    }
};